import {http} from '@/http/index.js';

async function getFollowingGirls(consumerId) {
  return http
    .get(`/consumers/${consumerId}/girls`)
    .then((response) => response.data);
}

export {getFollowingGirls};
